import React from 'react';

const Footer = () => {
  return (
    <footer class="footer container">
            
    </footer>
  )
}

export default Footer;